<template>
  <div class="switch">
    <button
      v-for="(item, index) in data"
      :key="index"
      :class="{ active: value === item.value }"
      @click="changeSwitch(item.value)"
    >
      {{ item.label }}
    </button>
  </div>
</template>

<script>
export default {
  name: 'Switcher',
  props: {
    value: {
      type: [Number, String, Boolean],
      required: true
    },

    data: {
      type: Array,
      default: () => []
    }
  },

  methods: {
    changeSwitch(value) {
      this.$emit('input', value)
    }
  }
}
</script>

<style scoped lang="scss">
.switch {
  border: 1px solid $luchmara;
  border-radius: 12px;
  padding: 3px;
  height: 100%;
  display: flex;
  align-items: center;
  margin-right: 12px;
  height: 32px;
  background: $alabaster;

  @include sm-and-down {
    width: 100%;
    flex-shrink: 0;
  }

  button {
    height: 100%;
    width: 128px;
    border-radius: 10px;
    letter-spacing: 0.2px;
    font-weight: 500;
    font-size: 13px;
    line-height: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: $luchmara;

    @include sm-and-down {
      width: 100%;
    }

    &:not(:last-of-type) {
      margin-right: 3px;
    }

    &.active {
      background: $luchmara;
      color: $white;
      box-shadow: 0 0 4px rgba($luchmara, 0.25);
    }
  }
}
</style>
